import React from 'react';

const Microsoft: React.FC<{}> = () => {
    return (
        <g id="path">
            <rect x="16" y="16" width="232" height="232" fill="#f25022"/>
            <rect x="264" y="16" width="232" height="232" fill="#7fba00"/>
            <rect x="16" y="264" width="232" height="232" fill="#00a4ef"/>
            <rect x="264" y="264" width="232" height="232" fill="#ffb900"/>
        </g>
    )
};


export default Microsoft;

